import { useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import FilterRow from "components/ListingComponents/filterRow";
import ListingTableData from "components/ListingComponents/listingTableData";
import { ListingTableHeader } from "components/ListingComponents/listingTableHeader";
import customAlert from "components/MDAlert/customAlert";
import { PreserveTable, useCache } from "context";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import WildlifeAuctionService from "services/wildlife-auction-service";
import authPermission from "utility/auth-permissions";
import { genderOptions } from "utility/constant-dropdown";
import { numberFormat } from "utility/helpers";

export default function data(props) {
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/active-listings");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value, show_filter, filter_data } =
    preserveTable?.wildlifeAuctionClosed;
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [wildlifeAuctionData, setWildlifeAuctionData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = React.useState("");
  const [totalData, setTotalData] = useState(0);
  const { cacheItems, setCacheItems } = useCache();
  const [previewRow, setPreviewRow] = useState(null);
  const hoverTimer = React.useRef(null);
  const [isData, setIsData] = useState(false);
  const [filterData, setFilterData] = useState(filter_data);
  const [filterLoading, setFilterLoading] = useState({
    search_loading: false,
    clear_loading: false,
  });
  const [wlIdsOptions, setWlIdsOptions] = useState([]);
  const [wlStatusOptions, setWlStatusOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [excelRows, setExcelRows] = useState([]);
  const [headerChecked, setHeaderChecked] = useState(false);
  const [maxError, setMaxError] = useState(false);
  const [key, setKey] = useState(0); // force remount
  // Add separate state for date range input
  const [dateRange, setDateRange] = useState({
    startDate: filterData?.start_date || null,
    endDate: filterData?.end_date || null,
  });
  const location = useLocation();

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setOpenGender(false);
  };

  const getAllCloselist = async () => {
    try {
      const response = await WildlifeAuctionService.getListingCategories(false);
      var wlIdsArray = [];
      var wlTypeArray = [{
        key: 'New',
        value: 'New',
      }, {
        key: 'Existing',
        value: 'Existing',
      }];

      var categoryArray = [{
        key: 'All',
        value: 'All',
      }];
      if (response) {
        response?.map(category => {
          if (category) {
            categoryArray.push({
              key: category,
              value: category,
            });
          }
        });
      }

      setWlIdsOptions(wlTypeArray);
      setCategoryOptions(categoryArray);
      setWlStatusOptions([{
        key: 'Sold',
        value: 'Sold',
      }, {
        key: 'Not Sold',
        value: 'Not Sold',
      }]);
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: 'error', icon: 'warning', msg: res.message, title: 'Auction Listing' });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({ color: 'error', icon: 'warning', msg: res.errors[0].detail, title: 'Auction Listing' });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
  }

  useEffect(() => {
    if (show_filter) {
      getAllCloselist();
    }
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
  }, []);

  const getWildlifeAuctionsData = async (page, pageSize, sortColumn, sortColumnValue, searchValue, clearSearch = true) => {
    let response = '';
    if (clearSearch) {
      response = await WildlifeAuctionService.getWildlifeAuctions(
        page,
        pageSize,
        sortColumn,
        sortColumnValue,
        searchValue,
        0
      );
    } else {
      response = await WildlifeAuctionService.getWildlifeAuctions(
        page,
        pageSize,
        sortColumn,
        sortColumnValue,
        searchValue,
        0,
        filterData,
      );
    }
    setWildlifeAuctionData(response?.data);
    setTotalData(response?.total);
    setIsData(true);
    //Logic to set the value for header checkbox for selecting excel rows
    const currentPageIds = response?.data.map(item => item.id);
    if (currentPageIds.length > 0) {
      for (let i = 0; i < currentPageIds.length; i++) {
        if (!excelRows.includes(currentPageIds[i])) {
          setHeaderChecked(false);
          return; // break early if any ID is not included
        }
      }

      // All IDs are present
      setHeaderChecked(true);
    } else {
      setHeaderChecked(false);
    }
  };

  const listSearchHandler = async (e, clearSearch) => {
    e.preventDefault();
    if (clearSearch) {

      // create new object with same keys but empty values
      const clearedFilters = Object.fromEntries(
        Object.keys(filterData).map((key) => [key, ""])
      );
      setKey(prev => prev + 1);
      setDateRange({ startDate: null, endDate: null }); // <-- reset the picker

      setFilterData(clearedFilters);
      setFilterLoading({
        ...filterLoading,
        clear_loading: true,
      });
      var preserveData = {
        "page_no": page_no,
        "page_size": page_size,
        "sort_column": sort_column,
        "sort_column_value": sort_column_value,
        "search_value": search_value,
        "show_filter": true,
        "filter_data": clearedFilters,
      };
      preserveTable.setPreserveWildlifeAuctionClosed(preserveData);
    } else {
      setFilterLoading({
        ...filterLoading,
        search_loading: true,
      });

      var preserveData = {
        "page_no": page_no,
        "page_size": page_size,
        "sort_column": sort_column,
        "sort_column_value": sort_column_value,
        "search_value": search_value,
        "show_filter": true,
        "filter_data": filterData,
      };
      preserveTable.setPreserveWildlifeAuctionClosed(preserveData);
    }
    await getWildlifeAuctionsData(page_no, page_size, sort_column, sort_column_value, search_value, clearSearch);
    setFilterLoading({
      search_loading: false,
      clear_loading: false,
    });
  };

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
      show_filter: show_filter,
      filter_data: filterData,
    };
    preserveTable.setPreserveWildlifeAuctionClosed(preserveData);
    getWildlifeAuctionsData(page_no, page_size, sortColumn, sortColumnValue, searchWord, false);
  };

  const filterOn = async () => {
    getAllCloselist();
    var preserveData = {
      "page_no": page_no,
      "page_size": page_size,
      "sort_column": sort_column,
      "sort_column_value": sort_column_value,
      "search_value": "",
      "show_filter": true,
      "filter_data": filterData,
    };
    preserveTable.setPreserveWildlifeAuctionClosed(preserveData);
    await getWildlifeAuctionsData(page_no, page_size, sort_column, sort_column_value, "");
  }

  const filterOff = async () => {
    setFilterData({});
    setKey(prev => prev + 1);
    setDateRange({ startDate: null, endDate: null }); // <-- reset the picker
    var preserveData = {
      "page_no": page_no,
      "page_size": page_size,
      "sort_column": sort_column,
      "sort_column_value": sort_column_value,
      "search_value": "",
      "show_filter": false,
      "filter_data": {},
    };
    preserveTable.setPreserveWildlifeAuctionClosed(preserveData);
    await getWildlifeAuctionsData(page_no, page_size, sort_column, sort_column_value, "");
  }

  function ucwords(str) {
    return str
      .toLowerCase()
      .replace(/\b\w/g, char => char.toUpperCase());
  }
  const deleteWildlifeAuction = async (id) => {
    try {
      const response = await WildlifeAuctionService.deleteWildlifeAuction(id);
      if (response) {
        if (cacheItems.hasOwnProperty("wildlife_auctions")) {
          // Create a new object without the key
          const { wildlife_auctions, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: response, title: "Auction Listing" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Auction Listing" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Auction Listing",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
    const res = await WildlifeAuctionService.getWildlifeAuctions(
      page_no,
      page_size,
      sort_column,
      sort_column_value,
      search_value
    );
    setWildlifeAuctionData(res?.data);
    setTotalData(res?.total);
    setSelectedId("");
    handleClose();
  };

  //Function to add ids checked for excel download
  const handleAddRowToExcel = (id) => {
    setExcelRows((prevRows) => {
      if (prevRows.includes(id)) {
        // remove it
        return prevRows.filter((rowId) => rowId !== id);
      } else {
        // add it
        return [...prevRows, id];
      }
    });
  }

  const [openGender, setOpenGender] = useState(false);
  const [formData, setFormData] = useState({
    source: "",
    title: "",
    subtitle: "",
    seller: "",
    listing_type: "",
    price: "",
    listing_id: "",
    listing_url: "",
    image_url: "",
    category: "",
    species: "",
    description: "",
    reserve_status: "",
    remaining_time: "",
    status: "",
    start_date: "",
    end_date: "",
    active: 0,
    male: 0,
    female: 0,
    male_calf: 0,
    female_calf: 0,
    unsexed_calf: 0,
    edited_columns: "",
  });

  const handleEdit = (data, id) => {
    setFormData({
      id: id,
      source: data?.source || "",
      title: data?.title || "",
      subtitle: data?.subtitle || "",
      seller: data?.seller || "",
      listing_type: data?.listing_type || "",
      price: data?.price || "",
      listing_id: data?.listing_id || "",
      listing_url: data?.listing_url || "",
      image_url: data?.image_url || "",
      category: data?.category || "",
      species: data?.species || "",
      description: data?.description || "",
      reserve_status: data?.reserve_status || "",
      remaining_time: data?.remaining_time || "",
      status: data?.status || "",
      start_date: data?.start_date || "",
      end_date: data?.end_date || "",
      active: 0,
      male: data?.male || 0,
      female: data?.female || 0,
      male_calf: data?.male_calf || 0,
      female_calf: data?.female_calf || 0,
      unsexed_calf: data?.unsexed_calf || 0,
      edited_columns: JSON.stringify(['gender']),
    });
    setOpenGender(true);
  };

  const handleSave = async (formData) => {
    const id = formData.id;
    try {
      const response = await WildlifeAuctionService.updateWildlifeAuction(id, formData);
      if (response) {
        if (cacheItems.hasOwnProperty("wildlife_auctions")) {
          // Create a new object without the key
          const { wildlife_auctions, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        await getWildlifeAuctionsData(page_no, page_size, sort_column, sort_column_value, search_value, false);
        openAlertSB({
          color: "success",
          icon: "check",
          msg: "Auction Updated Successfully!",
          title: "Auction Listing",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Auction Listing" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Auction Listing",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
      openAlertSB({
        color: "success",
        icon: "check",
        msg: "Auction Updated Successfully!",
        title: "Auction Listing",
      });
      setTimeout(function () {
        closeAlertSB();
      }, 4000);
    }
    setOpenGender(false);
  };

  //Function to add all the ids of present page to eixcel download
  const onHeaderChange = (checked) => {
    if (checked) {
      // Include all IDs from the current page
      const allIds = wildlifeAuctionData.map((item) => item.id);
      setExcelRows((prevRows) => {
        // Merge with existing IDs without duplicates
        const newRows = [...prevRows];
        allIds.forEach((id) => {
          if (!newRows.includes(id)) newRows.push(id);
        });
        return newRows;
      });
    } else {
      // Remove only IDs of current page
      const currentPageIds = wildlifeAuctionData.map((item) => item.id);
      setExcelRows((prevRows) => prevRows.filter((id) => !currentPageIds.includes(id)));
    }
    setHeaderChecked(checked);
  }

  const allRows = [];
  let totalAnimalCount = 0;
  let totalPrice = 0;
  let totalMale = 0;
  let totalMalePrice = 0;
  let totalFemale = 0;
  let totalFemalePrice = 0;
  let totalMaleCalf = 0;
  let totalMaleCalfPrice = 0;
  let totalFemaleCalf = 0;
  let totalFemaleCalfPrice = 0;
  let totalUnsexedCalf = 0;
  let totalUnsexedCalfPrice = 0;

  wildlifeAuctionData?.map((eachWildlifeAuction, index) => {
    const images = eachWildlifeAuction.image_url
      ? eachWildlifeAuction.image_url.split(",")
      : [];
    const editedColumns = eachWildlifeAuction.edited_columns ? JSON.parse(eachWildlifeAuction.edited_columns) : [];
    //Calculation for summary variables. If any listing selected then use that otherwise all listings
    if (excelRows.length === 0 || excelRows.includes(eachWildlifeAuction.id)) {
      let final_price = Number(eachWildlifeAuction.price);
      let final_count = Number(eachWildlifeAuction.male) + Number(eachWildlifeAuction.female) + Number(eachWildlifeAuction.male_calf) + Number(eachWildlifeAuction.female_calf) + Number(eachWildlifeAuction.unsexed_calf);
      let avg_price = final_count > 0 ? final_price / final_count : 0;

      totalMale += Number(eachWildlifeAuction.male);

      totalFemale += Number(eachWildlifeAuction.female);
      totalMaleCalf += Number(eachWildlifeAuction.male_calf);
      totalFemaleCalf += Number(eachWildlifeAuction.female_calf);
      totalUnsexedCalf += Number(eachWildlifeAuction.unsexed_calf);

      totalPrice += Number(eachWildlifeAuction.price);

      totalMalePrice += Number(eachWildlifeAuction.male) * avg_price;
      totalFemalePrice += Number(eachWildlifeAuction.female) * avg_price;
      totalMaleCalfPrice += Number(eachWildlifeAuction.male_calf) * avg_price;
      totalFemaleCalfPrice += Number(eachWildlifeAuction.female_calf) * avg_price;
      totalUnsexedCalfPrice += Number(eachWildlifeAuction.unsexed_calf) * avg_price;
    }
    const eachData = ListingTableData({
      data: eachWildlifeAuction,
      images: images,
      excelRows,
      pagePermission,
      handleAddRowToExcel,
      handleEdit,
      handleClickOpen,
      editedColumns,
      renderAlertSB,
      type: "default", // or "default"
    });
    allRows[index] = eachData;
  });

  const firstRow = FilterRow({
    filterData,
    setFilterData,
    wlIdsOptions,
    categoryOptions,
    genderOptions,
    listSearchHandler,
    maxError,
    setMaxError,
    dateRange,
    setDateRange,
    keyProp: key,
    filterLoading,
    renderAlertSB,
  });
  if (show_filter) {
    allRows.unshift(firstRow);
  }

  totalAnimalCount += Number(totalMale) + Number(totalFemale) + Number(totalMaleCalf) + Number(totalFemaleCalf) + Number(totalUnsexedCalf);
  // Calculate summary data
  const summaryData = {
    total_count: totalAnimalCount,
    total_price: numberFormat(totalPrice, true),
    avg_price: numberFormat((totalAnimalCount > 0 ? totalPrice / totalAnimalCount : 0), true),
    gender_stats: [
      { label: 'Male', count: totalMale, price: numberFormat(totalMalePrice, true), avg_price: numberFormat(totalMale > 0 ? totalMalePrice / totalMale : 0, true) },
      { label: 'Female', count: totalFemale, price: numberFormat(totalFemalePrice, true), avg_price: numberFormat(totalFemale > 0 ? totalFemalePrice / totalFemale : 0, true) },
      { label: 'Male Calf', count: totalMaleCalf, price: numberFormat(totalMaleCalfPrice, true), avg_price: numberFormat(totalMaleCalf > 0 ? totalMaleCalfPrice / totalMaleCalf : 0, true) },
      { label: 'Female Calf', count: totalFemaleCalf, price: numberFormat(totalFemaleCalfPrice, true), avg_price: numberFormat(totalFemaleCalf > 0 ? totalFemaleCalfPrice / totalFemaleCalf : 0, true) },
      { label: 'Unsexed Calf', count: totalUnsexedCalf, price: numberFormat(totalUnsexedCalfPrice, true), avg_price: numberFormat(totalUnsexedCalf > 0 ? totalUnsexedCalfPrice / totalUnsexedCalf : 0, true) },
    ]
  };

  return {
    columns: ListingTableHeader({headerChecked,onHeaderChange,pagePermission}),
    rows: allRows,
    open,
    handleClickOpen,
    handleClose,
    deleteWildlifeAuction,
    selectedId,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    pagePermission,
    show_filter: show_filter,
    filterOn: filterOn,
    filterOff: filterOff,
    isData: isData,
    openAlertSB,
    closeAlertSB,
    excelRows,
    openGender,
    formData,
    setFormData,
    handleSave,
    summaryData,
  };
}
